import './MainPageSub06_1.scss';

import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

const MainPageSub06_1 = () => {

   
    //=====================================================================
    return (
        <div className="MainPageSub06_1">
            <section className='sec-main'>

                <p className="heading-1 title1">
                    06 <span className="i-custom">역량을 담다</span>
                </p>

                <section className='sec-sub1'>
                    <article className='art-main'>
                       
            
                    <section className="description2" data-aos="fade-down" data-aos-delay="0">
                            <p>
                                <mark>우리 아이,</mark> 어느 영역에서 문제점이 보입니까? <br />
                                이것부터 찾아내어 <mark>Balance를 맞춰 나가는 것</mark>이 <u>아이공</u>의 <u>존재 이유</u>입니다!!
                            </p>
                        </section>


                        <section className="cube">
                            <ul className="not-dot">
                                {/* 일반 li 요소들 */}
                                <li data-aos="fade-up" data-aos-delay="0"></li>
                                <li data-aos="fade-up" data-aos-delay="100"></li>
                                <li data-aos="fade-up" data-aos-delay="200"></li>
                                <li data-aos="fade-up" data-aos-delay="300"></li>
                                <li data-aos="fade-up" data-aos-delay="400">장기기억</li>

                                <li data-aos="fade-left" data-aos-delay="500">추론유추<br/>능력</li>
                                <li data-aos="fade-left" data-aos-delay="600">비판능력</li>
                                <li data-aos="fade-left" data-aos-delay="700"></li>
                                <li data-aos="fade-left" data-aos-delay="800"></li>
                                <li data-aos="fade-left" data-aos-delay="900">진학관리</li>
                                <li className='red' data-aos="fade-left" data-aos-delay="1000">내신관리</li>

                                {/* red 클래스 요소만 flip 적용 */}
                                <li className="red" data-aos="flip-left" data-aos-delay="1100">동기부여</li>
                                <li data-aos="zoom-in" data-aos-delay="1200">멘탈관리</li>
                                <li data-aos="zoom-in" data-aos-delay="1300"></li>
                                <li data-aos="zoom-in" data-aos-delay="1400">독서총량</li>
                                <li className="red" data-aos="flip-left" data-aos-delay="1500">독해능력</li>
                                <li data-aos="zoom-in" data-aos-delay="1600">어휘선택</li>
                                <li data-aos="zoom-in" data-aos-delay="1700"></li>
                                <li data-aos="zoom-in" data-aos-delay="1800">습관지구력</li>
                                <li data-aos="zoom-in" data-aos-delay="1900">루틴지속력</li>
                                {/* <li data-aos="zoom-in" data-aos-delay="2000">입시전략</li> */}
                                <li className="red" data-aos="flip-left" data-aos-delay="1500">입시전략</li>
                                <li data-aos="zoom-in" data-aos-delay="2100"></li>

                                <li data-aos="fade-down" data-aos-delay="2200">집중능력</li>
                                <li className="red" data-aos="flip-left" data-aos-delay="2300">목표의식</li>
                                <li data-aos="fade-down" data-aos-delay="2400">이행능력</li>
                                <li className="red" data-aos="flip-left" data-aos-delay="2500">독서능력</li>
                                <li data-aos="fade-down" data-aos-delay="2600">독서시간</li>
                                <li className="red" data-aos="flip-left" data-aos-delay="2700">어휘확장<br/>능력</li>
                                <li data-aos="fade-down" data-aos-delay="2800">비문학어휘</li>
                                <li className="red" data-aos="flip-left" data-aos-delay="2900">자기주도</li>
                                <li data-aos="fade-down" data-aos-delay="3000">시간관리</li>
                                <li data-aos="fade-down" data-aos-delay="3100">대인관계력</li>
                                <li data-aos="fade-down" data-aos-delay="3200">소통능력</li>

                                <li data-aos="fade-down" data-aos-delay="3300"></li>
                                <li data-aos="fade-down" data-aos-delay="3400">계획능력</li>
                                <li data-aos="fade-down" data-aos-delay="3500">몰입능력</li>
                                <li data-aos="fade-down" data-aos-delay="3600"></li>
                                <li data-aos="fade-down" data-aos-delay="3700"></li>
                                <li data-aos="fade-down" data-aos-delay="3800">문학어휘</li>
                                <li className="red" data-aos="flip-left" data-aos-delay="3900">표현능력</li>
                                <li data-aos="fade-down" data-aos-delay="4000">구슬능력</li>
                                <li data-aos="fade-down" data-aos-delay="4100">논술능력</li>
                                <li data-aos="fade-down" data-aos-delay="4200"></li>
                                <li data-aos="fade-down" data-aos-delay="4300"></li>
                            </ul>
                        </section>

                   
                    </article>

                </section>

            </section>
        </div>
    );
};

export default MainPageSub06_1;
